import goldenRatio from '@glass/common/modules/goldenRatio/goldenRatio';

export const DEFAULT_SPACING = 10;
export const SMALL_SPACING = DEFAULT_SPACING / goldenRatio;
export const EXTRA_SMALL_SPACING = SMALL_SPACING / goldenRatio;
